import { BarChart3, MonitorSmartphone, ReceiptText } from "lucide-react"

import { t } from "@/lib/i18n"
import { cn } from "@/lib/utils"

import { LandingSection, SectionRule, SectionTitle } from "./section-rule"

const pillars = [
  { key: "web", icon: MonitorSmartphone },
  { key: "paperless", icon: ReceiptText },
  { key: "insights", icon: BarChart3 },
]

export function SelfServiceSection() {
  return (
    <LandingSection id="self-service">
      <SectionRule>{t("ui.landing.self_service.label")}</SectionRule>

      <div className="mt-6 grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionTitle>{t("ui.landing.self_service.title")}</SectionTitle>
          <p className="mt-5 text-pretty text-base leading-7 text-muted-foreground">
            {t("ui.landing.self_service.body_first")}
          </p>
          <p className="mt-4 text-pretty text-base leading-7 text-muted-foreground">
            {t("ui.landing.self_service.body_second")}
          </p>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 sm:gap-8">
            {["waiter", "kitchen"].map((key) => (
              <div key={key} className="border-t border-foreground pt-4">
                <h3 className="text-sm font-semibold">{t(`ui.landing.self_service.${key}.title`)}</h3>
                <p className="mt-1.5 text-sm leading-6 text-muted-foreground">
                  {t(`ui.landing.self_service.${key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          {pillars.map((pillar, index) => {
            const Icon = pillar.icon
            return (
              <div
                key={pillar.key}
                className={cn(
                  "grid grid-cols-[2.5rem_minmax(0,1fr)] gap-4 border-t py-6",
                  index === pillars.length - 1 && "border-b"
                )}
              >
                <span className="grid size-10 place-items-center rounded-lg bg-brand-subtle text-brand-ink">
                  <Icon className="size-5" strokeWidth={1.75} aria-hidden />
                </span>
                <span className="flex flex-col gap-1.5">
                  <span className="text-lg font-semibold tracking-tight">
                    {t(`ui.landing.pillars.${pillar.key}.title`)}
                  </span>
                  <span className="text-sm leading-6 text-muted-foreground">
                    {t(`ui.landing.pillars.${pillar.key}.description`)}
                  </span>
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </LandingSection>
  )
}
